import { IImportFile } from 'egi/app/Import/importInterfaces'
import { ImportTypes } from './importActions'
import { IImportActionsTypes } from './importActionTypes'

export interface INotaryFeesReducer {
  importItem: IImportFile | undefined
  percentage: number
  status: string | null
  antdStatus: 'success' | 'active' | 'normal' | 'exception' | undefined
}

const initialState = {
  percentage: 0,
  status: null,
  antdStatus: 'active',
  importItem: undefined
}

export const loadingReducer = (
  state = initialState,
  action: IImportActionsTypes.allActions
) => {
  switch (action.type) {
    case ImportTypes.SET_PERCENTAGE:
      return {
        ...state,
        percentage: action.payload
      }
    case ImportTypes.SET_STATUS:
      return {
        ...state,
        status: action.payload
      }

    case ImportTypes.SET_ANTD_STATUS:
      return {
        ...state,
        antdStatus: action.payload
      }

    case ImportTypes.SET_IMPORT_FILE:
      return {
        ...state,
        importItem: action.payload
      }
    case ImportTypes.RESET:
      return initialState
    default:
      return state
  }
}

export default loadingReducer
